import React, { useContext } from "react";
import { CustomerContext } from "./CustomerContext";
import { Link,Outlet } from "react-router-dom";
import "./customerTransporters.css"
import Pagination from "../../Pagination";
import Spinner from "../../Spinner";
export default function CustomerTransporter(){
  const {availableTransporters,formik,customerTransData,setRelToDel,newCustomerTransData,postsPerPage,paginate,currentPage}=useContext(CustomerContext)  
     const shouldPaginate=customerTransData.length>4
     const displayedTrans=shouldPaginate?newCustomerTransData:customerTransData
   
     

    return (
      <div className="mt-2  mb-16">        
        <div>
        <Link to="/customerDash/communicate/transOwners" className="hover:text-blue-500">transOwners</Link>
        <Outlet/>
        </div>
        <div className="mt-4 mb-10">
        {displayedTrans.length > 0 ?
          <div className="transporter-grid  max-w-full min-w-fit ">
            {displayedTrans.map((transporter, index) => (
              <div className="transporter-card" key={transporter.id}>
                <div className="transporter-container">
                  <div className="top-0 right-5">                      
                    <form onSubmit={formik.handleSubmit}>
                      <button className="bg-red-500 text-white rounded-full delete-button" onClick={() => {
                        formik.setFieldValue("name", transporter.name);
                        setRelToDel(true);
                      }} type="submit">DELETE</button>
                    </form>
                  </div>
                  <img src={transporter.image_url} alt={transporter.name} className="transporter-image"  />
                  <div key={index} className="data-overlay">
                    <p className="text-white italic">{transporter.name}</p>
                    <h4 className="text-white italic">{transporter.location}</h4>
                    <p className="text-white italic">{transporter.email}</p>
                  </div>
                </div>
              </div>

            ))}
            {shouldPaginate?<Pagination postsPerPage={postsPerPage} totalPosts={customerTransData.length} currentPage={currentPage} paginate={paginate}/>:null}
          </div> : <p>You seem to have no transporter,want  to add</p>}
      </div>    
        {availableTransporters.length>0 ?
        <div className=" overflow-auto">         
        <label htmlFor="name">select a transporter to add</label>
        <form onSubmit={formik.handleSubmit} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
          <select className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          name="name" id="name" value={formik.values.name} onChange={formik.handleChange}>
            <option value="">Select a transporter</option>
            {availableTransporters.map((trans,index)=>(
              <option key={index} value={trans.name}>{trans.name}</option>
            ))}
          </select>
          <button type="submit" className=" bg-blue-500 rounded-full disabled:opacity-50"  disabled={formik.isSubmitting || !formik.isValid} onClick={(e)=>{setRelToDel(false)}}>Send request</button>
        </form>
        </div>:null}
</div>
    )
   
}
